export default "__VITE_ASSET__0943b404__"